import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewListWrapperComponent } from './customer-review-list-wrapper.component';

runClientComponent({ CustomerReviewListWrapperComponent: CustomerReviewListWrapperComponent });
